import React, { useEffect, useState } from "react";
import QrModal from "../Modals/QrModal";
//import { Alert } from "react-bootstrap";
import { playScanOkSound } from "../../utils/playSounds";
import { useTranslation } from "react-i18next";
import { useAssetsState } from '../../stores/AssetsProvider'
import { isEmptyStr } from '../../utils/objectutils'

const AssetScan = ({ handleClose, setSelectedAsset }) => {
  const [loading, setLoading] = useState(null);
  /*const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);*/
  const { t } = useTranslation();
  const {
    setFilter,
    tableIsLoading,
    totalCount, setTotalCount,
    assets, setAssets,
    resetFilter,
  } = useAssetsState()

  const handleResult = async (result) => {
    if(tableIsLoading || isEmptyStr(result))
    {
      return false;
    }
    playScanOkSound();
    resetFilter()
    setAssets([])
    setTotalCount(0)
    setLoading(true)
    //set filter + trigger call
    setFilter((prev) => ({
        ...prev,
        'filter.number': result,
    }))
  };
  useEffect(() => {
    if (loading && !tableIsLoading) {
        if(totalCount==1)
        {
            setSelectedAsset(assets[0])
            setLoading(false)
        }
    }
  }, [assets, loading, tableIsLoading, totalCount, setSelectedAsset]);
  //auto remove success message after couple sec.
  /*useEffect(() => {
    let timeout = null;
    if (success || error) {
      timeout = setTimeout(() => {
        setSuccess(null);
        setError(null);
      }, 3000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [success, error]);*/

  return (
    <div>
      <QrModal
        title={t("assetPage:assetScan")}
        handleClose={() => handleClose()}
        //qrModalError={error}
        handleResult={(r) => handleResult(r)}
        isLoading={tableIsLoading}
      >
      </QrModal>
    </div>
  );
};

export default AssetScan;
